import { combineEpics } from 'redux-observable';

import _epics from './errors.epics';

export const epics = combineEpics(_epics);

export default '';
